<template>
  <div>

    <!-- Available subscriptions-->
      <select v-model="selectedSubscription">
        <option value="" disabled>Select a subscription</option>
        <option v-for="subscription in subscriptions" v-bind:value="subscription"
          :key="subscription.id"
          :disabled="hasSubscription(subscription.id)">
          {{ subscription.type }} - {{ subscription.duration }} {{ subscription.duration_type }}
        </option>
      </select>
      <button @click="addSubscription()">Add</button>

      <!-- Current subscriptions -->
      <Subscription v-for="subscription in partner.subscriptions" :key="subscription.id" :subscription="subscription" :partner="partner"
        v-on:update="updateSubscription" v-on:remove="removeSubscription"/>

  </div>
</template>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>

<script>
import { mapState } from 'vuex'
import Subscription from '@/components/Subscription.vue'

export default {
  name: 'partnerSubscriptions',
  components: {
    Subscription
  },
  props: {
    partner: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState([
      'debugMode',
      'subscriptions'
    ])
  },
  data () {
    return {
      selectedSubscription: null,
    }      
  },
  methods: {
    hasSubscription(subscriptionType) {
       return this.partner.subscriptions.find((element) => element.subscription_id === parseInt(subscriptionType));
    },

    addSubscription () {
      if (!this.selectedSubscription) return
      this.$store.dispatch('addPartnerSubscription', {
        partner: this.partner,
        subscription: this.selectedSubscription 
      })
    },
    updateSubscription ({ subscription, params} ) {
      this.$store.dispatch('updatePartnerSubscription', {
          partner: this.partner,
          subscription: subscription,
          params: params
        })
    },
    removeSubscription ({subscription, partner}) {
      var response = confirm("Are you sure you want to remove this subscription?")
      if (response) {
        this.$store.dispatch('removePartnerSubscription', {
          partner: partner,
          subscription: subscription
        })
      }
    }
  }
}
</script>
